import { createTheme, ThemeProvider } from '@mui/material/styles'
import { type ReactNode } from 'react'
import { defaulTheme } from '../../../theme'

const OPEN_SANS = '"Open Sans", sans-serif'

const focusVisibleRing = (borderRadius: string): Record<string, unknown> => ({
  '&.Mui-focusVisible': {
    outline: '2px solid var(--blue-300)',
    outlineOffset: '2px',
    borderRadius
  }
})

// MUI builds each typography variant with its own fontFamily, so the base font is
// overridden per variant: a top-level fontFamily alone would leave inputs, labels,
// menus and table cells on the unloaded Roboto stack (rendering as Helvetica).
export const p2pTheme = createTheme(defaulTheme, {
  palette: {
    error: defaulTheme.palette.augmentColor({ color: { main: '#7C0732' } })
  },
  typography: {
    fontFamily: OPEN_SANS,
    body1: { fontFamily: OPEN_SANS, fontSize: '14px', lineHeight: 1.4 },
    body2: { fontFamily: OPEN_SANS, fontSize: '12px' },
    subtitle1: { fontFamily: OPEN_SANS },
    subtitle2: { fontFamily: OPEN_SANS },
    caption: { fontFamily: OPEN_SANS, fontSize: '12px' },
    overline: { fontFamily: OPEN_SANS }
  },
  components: {
    MuiFormLabel: {
      styleOverrides: {
        root: {
          fontFamily: OPEN_SANS,
          fontSize: '14px',
          lineHeight: 1.4,
          color: 'var(--grey-900)'
        }
      }
    },
    MuiFilledInput: {
      defaultProps: {
        hiddenLabel: true
      },
      styleOverrides: {
        root: {
          borderRadius: '6px',
          backgroundColor: 'var(--grey-50)',
          '&.MuiInputBase-multiline': {
            padding: '13px 16px',
            alignItems: 'flex-start'
          }
        },
        input: {
          padding: '13px 16px',
          '&::placeholder': {
            color: 'var(--grey-500)',
            opacity: 1
          }
        },
        inputMultiline: {
          padding: 0
        }
      }
    },
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          marginLeft: 0,
          marginRight: 0,
          gap: '12px'
        }
      }
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          padding: 0,
          color: 'var(--grey-900)',
          ...focusVisibleRing('50%')
        }
      }
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          padding: 0,
          color: 'var(--grey-900)',
          ...focusVisibleRing('4px')
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: 'Raleway',
          fontWeight: 600
        }
      }
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: '16px',
          border: '1px solid var(--blue-300)',
          boxShadow: 'var(--shadow-md)'
        }
      }
    }
  }
})

export const P2PThemeProvider = ({ children }: { children: ReactNode }): JSX.Element => (
  <ThemeProvider theme={p2pTheme}>{children}</ThemeProvider>
)
